// extracted by mini-css-extract-plugin
export default {"AnswerItem":"AnswerItem_AnswerItem__iGPPq","success":"AnswerItem_success__NMexo","error":"AnswerItem_error__Rpz0C"};